import {
    BlockNoteEditor,
    defaultProps,
    insertOrUpdateBlock,
} from "@blocknote/core";
import {
    createReactBlockSpec,
    DragHandleMenuProps,
    useBlockNoteEditor,
    useComponentsContext,
} from "@blocknote/react";
import { IconQuote, IconSeparator } from "@tabler/icons-react";
import { Separator } from "@/components/ui/separator";
import { color } from "framer-motion";
import { cn } from "@/lib/utils";

export const QuoteBlock = createReactBlockSpec(
    {
        type: "quoteblock",
        propSchema: {
            backgroundColor: defaultProps.backgroundColor,
            textColor: defaultProps.textColor,
            text: {
                default: "Quote",
            },
        },
        content: "inline",
    },
    {
        render: ({ block, editor, contentRef }) => {
            const { text, backgroundColor, textColor } = block.props;
            return (
                <blockquote
                    className="border-s-4 p-4"
                    style={{
                        color: textColor,
                    }}
                    id={block?.id}
                >
                    <p
                        ref={contentRef}
                        className={cn(
                            `min-w-[1ch] whitespace-pre-wrap break-words font-medium italic leading-relaxed outline-none`
                        )}
                        contentEditable={editor.isEditable}
                        onClick={(e) => {
                            e.stopPropagation();
                            e.currentTarget.focus();
                        }}
                    />
                </blockquote>
            );
        },
    }
);
export const insertQuoteBlock = () => ({
    title: "Quote",
    group: "Advanced",
    onItemClick: (editor: BlockNoteEditor) => {
        insertOrUpdateBlock(editor, {
            // @ts-ignore
            type: "quoteblock",
        });
    },
    aliases: ["quote", "formatting"],
    icon: <IconQuote />,
    subtext: "Quote block for highlighting text",
});
